<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="rules"
      size="medium"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('orderpackage_form_lable_product_type') || '产品类型'"
            prop="packageGoodsType"
            ><br />
            <el-radio-group
              size="small"
              v-model="formData.packageGoodsType"
              @change="clearPackageGoodsNo"
            >
              <el-radio-button label="M">
                {{ $l("orderpackage_form_lable_main_products") || "主产品" }}
              </el-radio-button>
              <el-radio-button label="D"
                >{{
                  $l("orderpackage_form_lable_detailed_products") ||
                    "明细规格产品"
                }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="proName" ref="packAge">
            <el-input
              size="small"
              clearable
              v-model="formData.packageGoodsNo"
              readonly
            >
              <el-button
                slot="append"
                size="small"
                icon="el-icon-finished"
                @click="showDiaolg"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="
              this.$l('orderpackage_form_lable_packaging_type') || '包装类型'
            "
          >
            <dict-select
              v-model="formData.packageType"
              url="/master/common/dict/biz"
              :body="{ dictType: 'packageType' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              this.$l('orderpackage_form_lable_packing_quantity') || '装箱数量'
            "
            prop="qty"
          >
            <el-input-number
              style="width: 100%"
              clearable
              v-model="formData.qty"
              :step="1"
              :precision="0"
              :min="0"
              :max="9999999"
              controls-position="right"
              :placeholder="$l('tips_goods_label_qty') || '请输入数量'"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l("INDEX.tips_question_save") || "是否要保存更改" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l("INDEX.btn_cancel") || "取消"
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l("INDEX.btn_no_save") || "不保存"
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l("INDEX.btn_save") || "保存"
        }}</el-button>
      </span>
    </el-dialog>
    <ChooseOrderGoodsSpecDialog
      :visible.sync="goodSpecVisible"
      :title="$l('dialog_label_add_order_goods_spec') || '添加订单产品规格'"
      :orderCode="orderCode"
      type="radio"
      :appendToBody="true"
      @close="goodSpecVisible = false"
      @confirm="chooseGoodSpecData"
    />
    <ChooseOrderGoodsDialog
      :title="
        this.$l('INDEX.order_goods_label_orderGoods_information') ||
          '新增订单产品'
      "
      type="radio"
      ref="goodsDiaolog"
      :visible="goodVisible"
      :orderCode="orderCode"
      @close="goodVisible = false"
      @confirm="chooseGoodData"
    />
  </div>
</template>
<script>
import validate from "@/libs/util.validate"
import ChooseOrderGoodsDialog from "@/views/factory/components/choose-order-goods/dialog.vue"
import ChooseOrderGoodsSpecDialog from "@/views/factory/components/choose-order-goods-spec/dialog.vue"
import EditLoading from "@/mixins/edit-loading"

export default {
  mixins: [EditLoading],
  props: {
    code: String,
    orderCode: String,
    disabled: Boolean,
    materialCode: String,
  },

  data() {
    return {
      proName: this.$l("orderpackage_form_lable_product_no") || "对应产品编号",
      goodVisible: false,
      goodSpecVisible: false,
      backDialogVisible: false,
      formData: { packageGoodsNo: "" },
      rules: {
        packageGoodsType: [
          {
            required: true,
            message:
              this.$l("form_label_please_select_product_type") ||
              "请选择产品类型",
            trigger: "blur",
          },
        ],
        packageGoodsNo: [
          {
            required: true,
            message:
              this.$l("form_label_please_select_corresponding_product") ||
              "请选择对应产品",
            trigger: "blur",
          },
        ],
        qty: [
          {
            required: true,
            message:
              this.$l("form_label_please_select_packing_quantity") ||
              "请输入装箱数量",
            trigger: "blur",
          },
        ],
      },
    }
  },
  components: { ChooseOrderGoodsDialog, ChooseOrderGoodsSpecDialog },
  mounted() {
    this.getData()
  },
  methods: {
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit("close")
    },
    clearPackageGoodsNo() {
      this.formData.packageGoodsNo = ""
      let type = this.formData.packageGoodsType
      if (type === "M") {
        this.proName =
          this.$l("INDEX.order_goods_label_orderGoodsNo") || "产品编号"
      } else if(type === "D") {
        this.proName =
          this.$l("orderpackage_form_lable_product_spec_no") || "产品规格编号"
      }
    },
    getData() {
      if (!this.code) return
      this.$api
        .orderGoodsPackageDetailApi({
          orderGoodsPackageCode: this.code,
        })
        .then((res) => {
          if (!res.body) return
          this.formData = res.body
          const { packageGoodsType, orderGoodsNo, orderGoodsSpecNo } = res.body
          if (packageGoodsType === "M") {
            this.proName =
              this.$l("INDEX.order_goods_label_orderGoodsNo") || "产品编号"
            this.formData.packageGoodsNo = orderGoodsNo
          } else if (packageGoodsType === "D") {
            this.proName =
              this.$l("orderpackage_form_lable_product_spec_no") ||
              "产品规格编号"
            this.formData.packageGoodsNo = orderGoodsSpecNo
          }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (!this.formData.packageGoodsNo) {
        this.$message.error("请选择" + this.proName)
        return
      }
      if (!this.orderCode && !this.materialCode) return
      this.loadingOpen()
      this.$api
        .orderGoodsPackageSaveApi({
          ...this.formData,
          orderCode: this.orderCode,
          materialCode: this.materialCode,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          })
          this.$emit("close")
          this.$emit("reload")
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    showDiaolg() {
      const result = this.formData.packageGoodsType
      if (!result) {
        this.$message.error("请选择产品类型")
        return
      }
      if (result === "M") {
        this.goodVisible = true
      } else if (result === "D") {
        this.goodSpecVisible = true
      }
    },
    chooseGoodData(data) {
      this.proName = this.$l("orderpackage_form_lable_product_no") || "产品编号"
      const { orderGoodsCode, orderGoodsNo } = data
      this.formData.packageGoodsNo = orderGoodsNo
      this.formData.packageGoodsCode = orderGoodsCode
    },
    chooseGoodSpecData(data) {
      this.proName =
        this.$l("orderpackage_form_lable_product_spec_no") || "产品规格编号"
      const { orderGoodsSpecCode, orderGoodsSpecNo } = data
      this.formData.packageGoodsNo = orderGoodsSpecNo
      this.formData.packageGoodsCode = orderGoodsSpecCode
    },
  },
}
</script>
